/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ImportPsasToEuTaxonomyDto } from '../models';
// @ts-ignore
import type { PsasDatasetResponseDto } from '../models';
/**
 * PSASApi - axios parameter creator
 * @export
 */
export const PSASApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves dataset data from PSAS API by public name
         * @summary Get dataset from PSAS API
         * @param {string} publicName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        psasControllerGetDataset: async (publicName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicName' is not null or undefined
            assertParamExists('psasControllerGetDataset', 'publicName', publicName)
            const localVarPath = `/api/psas/dataset/{publicName}`
                .replace(`{${"publicName"}}`, encodeURIComponent(String(publicName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches data from PSAS dataset, filters valid activity IDs, and imports them as EU Taxonomy activities
         * @summary Import PSAS dataset to EU Taxonomy activities
         * @param {ImportPsasToEuTaxonomyDto} importPsasToEuTaxonomyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        psasControllerImportToEuTaxonomy: async (importPsasToEuTaxonomyDto: ImportPsasToEuTaxonomyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importPsasToEuTaxonomyDto' is not null or undefined
            assertParamExists('psasControllerImportToEuTaxonomy', 'importPsasToEuTaxonomyDto', importPsasToEuTaxonomyDto)
            const localVarPath = `/api/psas/import-to-eu-taxonomy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importPsasToEuTaxonomyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches data from PSAS dataset and updates form draft questions with matching codes
         * @summary Import dataset data to form draft
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        psasControllerImportToForm: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('psasControllerImportToForm', 'formId', formId)
            const localVarPath = `/api/psas/import-to-form/{formId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PSASApi - functional programming interface
 * @export
 */
export const PSASApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PSASApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves dataset data from PSAS API by public name
         * @summary Get dataset from PSAS API
         * @param {string} publicName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async psasControllerGetDataset(publicName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PsasDatasetResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.psasControllerGetDataset(publicName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PSASApi.psasControllerGetDataset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches data from PSAS dataset, filters valid activity IDs, and imports them as EU Taxonomy activities
         * @summary Import PSAS dataset to EU Taxonomy activities
         * @param {ImportPsasToEuTaxonomyDto} importPsasToEuTaxonomyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async psasControllerImportToEuTaxonomy(importPsasToEuTaxonomyDto: ImportPsasToEuTaxonomyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.psasControllerImportToEuTaxonomy(importPsasToEuTaxonomyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PSASApi.psasControllerImportToEuTaxonomy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches data from PSAS dataset and updates form draft questions with matching codes
         * @summary Import dataset data to form draft
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async psasControllerImportToForm(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.psasControllerImportToForm(formId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PSASApi.psasControllerImportToForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PSASApi - factory interface
 * @export
 */
export const PSASApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PSASApiFp(configuration)
    return {
        /**
         * Retrieves dataset data from PSAS API by public name
         * @summary Get dataset from PSAS API
         * @param {string} publicName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        psasControllerGetDataset(publicName: string, options?: RawAxiosRequestConfig): AxiosPromise<PsasDatasetResponseDto> {
            return localVarFp.psasControllerGetDataset(publicName, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches data from PSAS dataset, filters valid activity IDs, and imports them as EU Taxonomy activities
         * @summary Import PSAS dataset to EU Taxonomy activities
         * @param {ImportPsasToEuTaxonomyDto} importPsasToEuTaxonomyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        psasControllerImportToEuTaxonomy(importPsasToEuTaxonomyDto: ImportPsasToEuTaxonomyDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.psasControllerImportToEuTaxonomy(importPsasToEuTaxonomyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches data from PSAS dataset and updates form draft questions with matching codes
         * @summary Import dataset data to form draft
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        psasControllerImportToForm(formId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.psasControllerImportToForm(formId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PSASApi - object-oriented interface
 * @export
 * @class PSASApi
 * @extends {BaseAPI}
 */
export class PSASApi extends BaseAPI {
    /**
     * Retrieves dataset data from PSAS API by public name
     * @summary Get dataset from PSAS API
     * @param {string} publicName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PSASApi
     */
    public psasControllerGetDataset(publicName: string, options?: RawAxiosRequestConfig) {
        return PSASApiFp(this.configuration).psasControllerGetDataset(publicName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches data from PSAS dataset, filters valid activity IDs, and imports them as EU Taxonomy activities
     * @summary Import PSAS dataset to EU Taxonomy activities
     * @param {ImportPsasToEuTaxonomyDto} importPsasToEuTaxonomyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PSASApi
     */
    public psasControllerImportToEuTaxonomy(importPsasToEuTaxonomyDto: ImportPsasToEuTaxonomyDto, options?: RawAxiosRequestConfig) {
        return PSASApiFp(this.configuration).psasControllerImportToEuTaxonomy(importPsasToEuTaxonomyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches data from PSAS dataset and updates form draft questions with matching codes
     * @summary Import dataset data to form draft
     * @param {string} formId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PSASApi
     */
    public psasControllerImportToForm(formId: string, options?: RawAxiosRequestConfig) {
        return PSASApiFp(this.configuration).psasControllerImportToForm(formId, options).then((request) => request(this.axios, this.basePath));
    }
}

